import React, { useState } from 'react'
import { withFirebase } from '../../../services'
import { FileUploadWithURL } from '../../../common'
import { Spinner } from 'evergreen-ui';

const ChatBox = (props) => {

    const { firebase , docID } = props

    const [isLoading, setLoading] = useState(false)
    const [noComment, setNoComment] = useState(false)
    const handleComment = (e) => {
        const value = e.target.value
    }

    const handleSubmit = (e) => {
        e.preventDefault()

    }


    return (

        <div className="center">
            <form onSubmit={handleSubmit}>
                <h2 className="form-title">Your comment:</h2>
                <div className="form-inner">
                    <textarea name="comment" className={noComment && "no-comment"} onChange={(e) => handleComment(e)}  cols="28" rows="5" placeholder="What made you satisfied?"></textarea>
                    
                    
                    {isLoading ? <div className="comment-loader"><Spinner size={35} /> </div> : <input type="submit" />}
                </div>
            </form>
        </div>

    )
}

export default withFirebase(ChatBox)
